stimulusApp.register(
  "room-filter-option",
  class extends Stimulus.Controller {
    static targets = ["input", "counter"]

    checked() {
      return this.inputTarget.checked
    }

    name() {
      return this.inputTarget.name
    }

    disabled() {
      return this.inputTarget.disabled
    }

    adjacency() {
      return this.element.dataset.adjacency
    }

    filter() {
      return { [this.name()]: new Set().add(this.inputTarget.value) }
    }

    update(value, cardsLoaded) {
      if (value === 0) {
        this.inputTarget.disabled = true
        this.inputTarget.checked = false

        if (cardsLoaded && this.element.dataset.required !== "true") {
          this.element.classList.add("hidden")
        }
      } else {
        this.inputTarget.disabled = false
        this.element.classList.remove("hidden")
      }

      this.counterTarget.innerText = value
    }
  },
)
